/**
 * Created By xiyuan
 * Author server@xiyuan.name (惜缘叛逆)
 * DateTime 2018/11/7 15:29
 * Describe modal 遮盖层
 * MIT License http://www.opensource.org/licenses/mit-license.php
 */

// 遮盖层级
let zIndex = 800;
// 遮盖元素
const modalEle = document.createElement('div');

// 遮盖层默认样式
const style = {
	top: 0,
	left: 0,
	width: '100%',
	height: '100%',
	position: 'fixed',
	zIndex: zIndex,
	opacity: 0,
	transition: 'opacity ease-out 0.3s',
	backgroundColor: 'rgba(0, 0, 0, 0.7)',
}

// 动画结束时间名称
let transitions = {
	'transition': 'transitionend',
	'OTransition': 'oTransitionEnd',
	'MozTransition': 'transitionend',
	'WebkitTransition': 'webkitTransitionEnd'
}

// 获取浏览器的动画事件名称
function whichTransitionEvent() {
	let el = document.createElement('surface');
	let nameList = Object.keys(transitions);
	let len = nameList.length;
	
	for (let i = 0; i < len; i++) {
		if (el.style[nameList[i]] !== undefined) {
			return transitions[nameList[i]];
		}
	}
}

// 获取事件名称
const transitionEvent = whichTransitionEvent();

// 写入动画样式到遮盖元素上
Object.keys(transitions).forEach(key => {
	style[key] = style.transition;
})

// 写入默认样式到遮盖元素上
Object.keys(style).forEach(key => {
	modalEle.style[key] = style[key];
})

// 关闭遮盖层处理
function close(context) {
	context.modalEle.style.opacity = 0;
	// 移除点击事件
	modalEle.removeEventListener('click', context.clickEvent);
	// 触发关闭事件
	(context.closeEvents || []).forEach(function (fn) {
		fn()
	})
}

// 动画回调
function transitionEventCallback(event) {
	if (event.target.style.opacity === '1') return
	let modalEle = event.target
	modalEle.style.display = 'none';
	//销毁事件
	modalEle.removeEventListener(transitionEvent, transitionEventCallback);
	// 移除元素
	modalEle.parentNode && modalEle.parentNode.removeChild(modalEle);
	// 恢复之前的层级
	zIndex--
}

export default class modal {
	constructor() {
		let context = this;
		// 关闭事件容器
		this.closeEvents = [];
		this.overlayClickEvents = [];
		// 遮盖层元素
		this.modalEle = modalEle.cloneNode(true);
		// 是否点击关闭
		this.closeOnClickOverlayToggle = true;
		// 点击事件
		this.clickEvent = function () {
			// 触发点击事件
			context.overlayClickEvents.forEach(function (fn) {
				fn(zIndex, context);
			})
			// 检查是否同一层
			if (context.zIndex != zIndex) return
			context.closeOnClickOverlayToggle && close(context);
		}
	}
	
	// 开启遮盖层
	open(element, callback, noneOverlay) {
		zIndex++;
		// 目标元素处理
		element = ({}.toString.call(element)).match('Element') ? element : document.body;
		callback = typeof element === "function" ? element : callback;
		
		if (noneOverlay) return callback(zIndex + 1);
		let modalEle = this.modalEle;
		modalEle.style.zIndex = this.zIndex = zIndex;
		modalEle.addEventListener('click', this.clickEvent);
		modalEle.addEventListener(transitionEvent, transitionEventCallback);
		modalEle.style.display = 'block';
		// 添加到dom文档中
		if (!document.body.contains(modalEle)) element.appendChild(modalEle);
		// 设置遮盖层的透明度
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				modalEle.style.opacity = 1;
			})
		})
		if (typeof callback === "function") {
			callback(zIndex + 1)
		}
	}
	
	// 关闭遮盖层
	close(noneOverlay) {
		if (noneOverlay) return zIndex--;
		close(this);
	}
	
	// 关闭事件监听
	onClose(callback) {
		this.closeEvents.push(callback)
	}
	
	// 浮层点击事件
	onOverlayClick(callback) {
		this.overlayClickEvents.push(callback)
	}
	
	// 设置是否点击关闭弹窗
	closeOnClickOverlay(toggle) {
		this.closeOnClickOverlayToggle = toggle;
	}
}